/**
 * 정비소 목록 페이지 프로모션 배너 PC fallback OneLink.
 * 모바일은 SmartScript 동적 OneLink (`?seoOnelink=`) 우선.
 * campaign: placelist_promotion_banner
 */
export const PLACE_LIST_PROMOTION_BANNER_ONELINK_URL =
  'https://web-seo-geo.onelink.me/kFy7/hjysgylx'
